export default {
    list: { method: 'post', url: 'v1/movida/scope/list' },
    show: { method: 'post', url: 'v1/movida/scope/show' },
    register: { method: 'post', url: 'v1/movida/scope/register' },
    edit: { method: 'post', url: 'v1/movida/scope/edit' },
    delete: { method: 'post', url: 'v1/movida/scope/delete' },
}